module.exports = __webpack_public_path__ + "img/product-gov-jggl.fc96c5b6.gif";